export default {
  name: 'scenario',
  translationKey: 'scenario-module',
  routePrefix: 'scenario',
  routeNamePrefix: 'admin.scenario',
  directRoutesAvailable: false,
}
